import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { AppTable } from '@/UI/AppTable/AppTable';
import { LabelSmRg } from '@/UI/AppTypography/AppTypography';
import type { EnhancedTableHeadProps, HeadCell, AllowedRecipeKeys } from '../types/listView.types';

export function EnhancedTableHead({
  order,
  orderBy,
  onRequestSort,
  isWorkspaceFiles,
  filesColumnLabel = 'Files',
  showFilesColumn = true,
}: EnhancedTableHeadProps) {
  const createSortHandler = (property: AllowedRecipeKeys) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  const headCells = (
    [
      { id: 'name', numeric: false, disablePadding: true, label: 'Name' },
      isWorkspaceFiles ? { id: 'ownerName', numeric: false, disablePadding: false, label: 'Owned by' } : null,
      showFilesColumn ? { id: 'files', numeric: true, disablePadding: false, label: filesColumnLabel } : null,
      { id: 'updatedAt', numeric: true, disablePadding: false, label: 'Last modified' },
      { id: 'createdAt', numeric: true, disablePadding: false, label: 'Created at' },
    ] satisfies Array<HeadCell | null>
  ).filter((cell) => cell !== null);

  return (
    <AppTable.Thead>
      <AppTable.Tr>
        {headCells.map((headCell) => (
          <AppTable.Th
            key={headCell.id}
            align={headCell.id === 'name' ? 'left' : 'center'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <AppTable.SortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              sx={{
                justifyContent: headCell.id === 'name' ? 'flex-start' : 'center',
              }}
            >
              <LabelSmRg color={token.text}>{headCell.label}</LabelSmRg>
            </AppTable.SortLabel>
          </AppTable.Th>
        ))}
      </AppTable.Tr>
    </AppTable.Thead>
  );
}
